import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { BrandOptions, StateOptions, ErpBankMasterOptions, InventoryStatusOptions, PomasterOptions, ProductOptions, 
 VendorOptions, CategoryOptions, SubCategoryOptions, InfraPomasterOptions, MeasuringunitOptions } from "app/_models/optionsList/options";

@Injectable({
  providedIn: 'root'
})
export class OptionslistService {
  private readonly _baseUrl: string;

  constructor(
    private readonly http: HttpClient
  ) {
    this._baseUrl = environment.baseUrl;
  }

  getVendorOptions() {
    return this.http.get<VendorOptions[]>(this._baseUrl + 'Optionlist/GetVendorOptions');
  }
  getBrandOptions() {
    return this.http.get<BrandOptions[]>(this._baseUrl + 'Optionlist/GetBrandOptions');
  }

  getStateOptions() {
    return this.http.get<StateOptions[]>(this._baseUrl + 'Optionlist/GetStateOptions');
  }

  getErpBankMasterOptions() {
    return this.http.get<ErpBankMasterOptions[]>(this._baseUrl + 'Optionlist/GetErpBankMasterOptions');
  }

  getInventoryStatusOptions() {
    return this.http.get<InventoryStatusOptions[]>(this._baseUrl + 'Optionlist/GetInventoryStatusOptions');
  }

  getPomasterOptions() {
    return this.http.get<PomasterOptions[]>(this._baseUrl + 'Optionlist/GetPomasterOptions');
  }

  getInfraPomasterOptions() {
    return this.http.get<InfraPomasterOptions[]>(this._baseUrl + 'Optionlist/GetInfraPomasterOptions');
  }

  getProductsOptions() {
    return this.http.get<ProductOptions[]>(this._baseUrl + 'Optionlist/GetProductsOptions');
  }

  getConsumableProductsOptions() {
    return this.http.get<ProductOptions[]>(this._baseUrl + 'Optionlist/GetConsumableProductsOptions');
  }


  getCategoryByProductOptions(productId: number) {
    return this.http.get<CategoryOptions[]>(this._baseUrl + 'Optionlist/GetCategoryByProductOptions?productId=' + productId);
  }

  getConsumableCategoryByProductOptions(productId: number) {
    return this.http.get<CategoryOptions[]>(this._baseUrl + 'Optionlist/GetConsumableCategoryByProductOptions?productId=' + productId);
  }

  getSubCategoryByCategoryOptions(categoryId: number) {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetSubCategoryByCategoryOptions?categoryId=' + categoryId);
  }
   
  getNonConSubCategoryByCategoryOptions(categoryId: number) {
    return this.http.get<SubCategoryOptions[]>(this._baseUrl + 'Optionlist/GetNonConSubCategoryByCategoryOptions?categoryId=' + categoryId);
  }
  getConSubCategoryByCategoryOptions(categoryId: number) {
    return this.http.get<SubCategoryOptions[]>(this._baseUrl + 'Optionlist/GetConSubCategoryByCategoryOptions?categoryId=' + categoryId);
  }
  getMeasuringunitOptions() {
    return this.http.get<MeasuringunitOptions[]>(this._baseUrl + 'Optionlist/GetMeasuringunits');
  }

  getInventorystatusOptions() {
    return this.http.get<InventoryStatusOptions[]>(this._baseUrl + 'Optionlist/GetInventoryStatusOptions');
  }

  getPurchaseorderOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetPurchaseorderOptions');
  }
  getNonConsumablePurchaseorderOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetNonConsumablePurchaseorderOptions');
  }

  getConsumablePurchaseorderOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetConsumablePurchaseorderOptions');
  }
  getPoBrandOptions(purchaseOrderId: number) {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetPoBrandOptions?purchaseOrderId=' + purchaseOrderId);
  }

  getPoProductOptions(purchaseOrderId: number) {
    return this.http.get<any>(this._baseUrl + 'Optionlist/getPoProductOptions?purchaseOrderId=' + purchaseOrderId);
  }

getCosnumablePoProductOptions(purchaseOrderId: number) {
  return this.http.get<any>(this._baseUrl + 'Optionlist/GetCosnumablePoProductOptions?purchaseOrderId=' + purchaseOrderId);
}

  getPoProductCategoryOptions(orderId: number, productId: number) {
    let request = { purchaseOrderId: orderId, productId: productId };
    return this.http.post<any>(`${this._baseUrl}Optionlist/GetPoProductCategoryOptions`, request);
  }

  getConsumablePoProductCategoryOptions(orderId: number, productId: number) {
    let request = { purchaseOrderId: orderId, productId: productId };
    return this.http.post<any>(`${this._baseUrl}Optionlist/GeConsumabletPoProductCategoryOptions`, request);
  }

  getInfraPoSubCategoryOptions(orderId: number, productId: number, catId: number) {
    let request = { purchaseOrderId: orderId, productId: productId, categoryId: catId };
    return this.http.post<any>(`${this._baseUrl}Optionlist/GetInfraPoSubCategoryOptions`, request);
  }

  getInfraPoConSubCategoryOptions(orderId: number, productId: number, catId: number) {
    let request = { purchaseOrderId: orderId, productId: productId, categoryId: catId };
    return this.http.post<any>(`${this._baseUrl}Optionlist/GetInfraPoConSubCategoryOptions`, request);
  }
  getConsumableInfraPoConSubCategoryOptions(orderId: number, productId: number, catId: number) {
    let request = { purchaseOrderId: orderId, productId: productId, categoryId: catId };
    return this.http.post<any>(`${this._baseUrl}Optionlist/GetInfraPoConSubCategoryOptions`, request);
  }
   
   
  getPoPrCatSubBrandOptions(orderId: number, productId: number, catId: number, subcatId: number) {
    let request = { purchaseOrderId: orderId, productId: productId, categoryId: catId, subCategoryId: subcatId };
    return this.http.post<any>(`${this._baseUrl}Optionlist/GetPoPrCatSubBrandOptions`, request);
  }

  getUserOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetUserOptions');
  }

  getActiveUserOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetActiveUserOptions');
  }

  getActiveDatacentereManagersOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetActiveDatacenterManagersOptions');
  }

  
  getTsiSiteOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetTsiSiteOptions');
  }

  getWareHouseWithMangerOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetWareHouseWithMangerOptions');
  }

  getWarehouseOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetWareHouseOptions');
  }

  getInvMovementstatusOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetInvMovementstatusOptions');
  }
  getConInventoryMovestatusOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetConInventoryMovestatusOptions');
  }
  getConInventoryAssigntatusOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetConInventoryAssignStatusOptions');
  }
  getTsiProjectOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetInvProjectOptions');
  }
  
  getInvProjectOptions() {
    return this.http.get<any>(this._baseUrl + 'Optionlist/GetInvProjectOptions');
  }

 
  
}
